<template>
  <div class="detailRole">
    <el-dialog
      :title="$t('role.detialTitle') + titleMenuAuthorize"
      :visible.sync="dialogDetail"
      :close-on-click-modal="false"
      width="55%"
      @close="closeDialog"
    >
      <el-row type="flex">
        <el-col :span="10">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('menu.menuTree') }}</span>
            </div>
            <el-tree
              ref="tree"
              :data="data"
              :props="defaultProps"
              show-checkbox
              :expand-on-click-node="false"
              default-expand-all
              highlight-current
              check-strictly
              node-key="id"
              :default-checked-keys="checkedIds"
              :style="{ height: heightTree, overflow: 'auto' }"
              @node-click="handleNodeClick"
            />
          </el-card>
        </el-col>
        <el-col :span="14">
          <el-card shadow="hover" class="box-card">
            <div slot="header" class="clearfix">
              <span>{{ $t('menu.menuBtn') }}：按钮名称-按钮类型</span>
            </div>
            <el-tree
              ref="btnTree"
              :data="tableData"
              :props="defaultProps"
              show-checkbox
              :expand-on-click-node="false"
              default-expand-all
              highlight-current
              check-strictly
              node-key="id"
              :style="{ height: heightTree, overflow: 'auto' }"
              :default-checked-keys="checkRowKeys"
              @check-change="handleBtnCheckChange"
              :render-content="renderContent"
            >
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <span>{{ node.label }} - {{ data.buttonLocation }}</span>
              </span>
            </el-tree>
          </el-card>
        </el-col>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="loading" @click="addSure()">{{
          $t('dialog.confirm')
        }}</el-button>
        <el-button @click="closeDialog()">{{ $t('dialog.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import API from '@/api/systemManage/role.js';
  import MENUAPI from '@/api/systemManage/menu.js';

  export default {
    name: 'DetailRole',
    data() {
      return {
        dialogDetail: false,
        titleMenuAuthorize: '',
        defaultProps: {
          children: 'children',
          label: 'label',
        },
        loading: false,
        role: {},
        data: [],
        chooseMenuId: '',
        checkedIds: [],
        tableData: [],
        checkRowKeys: [],
        hasChooseBtn: [],
        defalutChoosenBtn: [],
        changeMenuBtn: [],
      };
    },
    computed: {
      // 表格显示字段
      columnList() {
        return [
          {
            prop: 'buttonName',
            label: this.$t('menu.table.btnName'),
          },
        ];
      },
      heightTable() {
        return window.innerHeight - 370 + 'px';
      },
      heightTree() {
        return window.innerHeight - 370 + 'px';
      },
    },
    methods: {
      renderContent(h, { node, data }) {
        return (
          <span class="custom-tree-node">
            <span>{node.label} </span>
            <span style="font-size:12px">
              - {data.attributes.buttonLocation == 'list' ? '列表' : '其他'}
            </span>
          </span>
        );
      },
      closeDialog() {
        this.dialogDetail = false;
        this.changeMenuBtn = [];
      },
      openDialog(flag, val) {
        this.dialogDetail = flag;
        this.role = val;
        this.titleMenuAuthorize = val.roleName;
        this.getMenuData(val);
        this.getHasBotton(val);
      },
      // 获取菜单树
      getMenuData(val) {
        this.tableData = [];
        this.checkedIds = [];
        const params = {
          roleCode: val.roleCode,
          tenantCode: val.tenantCode,
          applicationCode: val.applicationCode,
        };
        this.$axios.post(MENUAPI.GET_LIST_API, params).then((res) => {
          if (res.data.code === 0) {
            this.data = res.data.data.rootTree;
            res.data.data.menuCodeList.forEach((item) => {
              this.checkedIds.push(item.menuCode);
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 获取该角色已有按钮
      getHasBotton(val) {
        this.defalutChoosenBtn = [];
        const params = {
          roleCode: val.roleCode,
        };
        this.$axios.post(API.GET_DEFALUT_LIST, params).then((res) => {
          if (res.data.code === 0) {
            res.data.data.checked.forEach((item) => {
              var obj = {
                menuCode: item.menuCode,
                buttonCode: item.buttonCode,
                authCode: item.authCode,
              };
              this.defalutChoosenBtn.push(obj);
            });
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // sxp add 20210121 按钮节点选中状态发生变化时的回调
      handleBtnCheckChange() {
        const row = this.$refs.btnTree.getCheckedNodes();
        this.changeMenuBtn.map((item) => {
          if (item.id == this.chooseMenuId) {
            item.select = row.map((i) => {
              return {
                menuCode: i.attributes.menuCode,
                buttonCode: i.attributes.buttonCode,
                authCode: i.attributes.authCode,
              };
            });
          }
        });
      },
      // 选择一条菜单
      handleNodeClick(data) {
        this.chooseMenuId = data.id;
        let isPost = true;
        let tableData = [];
        let checkRowKeys = [];
        this.changeMenuBtn.map((item) => {
          if (item.id == this.chooseMenuId) {
            isPost = false;
            tableData = item.buttons;
            checkRowKeys = item.select.map((i) => {
              return i.buttonCode;
            });
          }
        });
        if (isPost) {
          // 查询按钮信息
          this.findButtonList(data.id);
        } else {
          this.tableData = tableData;
          this.checkRowKeys = checkRowKeys;
        }
      },
      // 查询按钮信息
      findButtonList(menuCode) {
        this.checkRowKeys = [];
        this.hasChooseBtn = [];
        const params = {
          menuCode: menuCode,
          roleCode: this.role.roleCode,
        };
        this.$axios.post(MENUAPI.GET_BTN_LIST_API, params).then((res) => {
          // 查询按钮详情
          if (res.data.code === 0) {
            // 查询成功
            this.tableData = res.data.data.all;
            // 设置选中
            res.data.data.checked.forEach((item) => {
              this.checkRowKeys.push(item.buttonCode);
              this.hasChooseBtn.push({
                menuCode: item.menuCode,
                buttonCode: item.buttonCode,
                authCode: item.authCode,
              });
            });
            // 将查出来值存起来 下次点击菜单时不用再次请求
            const list = {
              id: this.chooseMenuId,
              buttons: this.tableData,
              select: this.hasChooseBtn,
            };
            this.changeMenuBtn.push(list);
          } else {
            this.$alert(res.data.msg);
          }
        });
      },
      // 保存
      addSure() {
        let tableBtn = [];
        let chooseMenuIds = [];
        this.changeMenuBtn.map((item) => {
          item.select.map((i) => {
            tableBtn.push(i);
          });
          chooseMenuIds.push(item.id);
        });
        for (let i = 0; i < chooseMenuIds.length; i++) {
          for (let j = 0; j < this.defalutChoosenBtn.length; j++) {
            if (chooseMenuIds[i] == this.defalutChoosenBtn[j].menuCode) {
              this.defalutChoosenBtn.splice(j, 1);
              j--;
            }
          }
        }
        this.defalutChoosenBtn = this.defalutChoosenBtn.concat(tableBtn);

        const select = this.$refs.tree.getCheckedKeys(); // 选中的菜单
        const halfSelect = this.$refs.tree.getHalfCheckedNodes(); // 半选中的菜单
        for (var j = 0; j < halfSelect.length; j++) {
          select.push(halfSelect[j].id);
        }
        this.newChoosenBtn = []; // 最终选中的按钮对象
        for (var l = 0; l < this.defalutChoosenBtn.length; l++) {
          for (var n = 0; n < select.length; n++) {
            if (this.defalutChoosenBtn[l].menuCode === select[n]) {
              var btnStr =
                this.defalutChoosenBtn[l].menuCode +
                ':' +
                this.defalutChoosenBtn[l].buttonCode +
                ':' +
                this.defalutChoosenBtn[l].authCode;
              this.newChoosenBtn.push(btnStr);
            }
          }
        }
        const params = {
          roleCode: this.role.roleCode,
          menuCodes: select,
          menuBtn: this.newChoosenBtn,
        };
        if (!this.loading) {
          this.loading = true;
          this.$axios.post(API.ADD_AUTH_ROLE_API, params).then((res) => {
            this.loading = false;
            if (res.data.code !== 0) {
              this.$alert(res.data.msg);
            } else {
              this.closeDialog();
              this.$emit('getData');
              this.$message({
                showClose: true,
                message: res.data.msg || this.$t('message.success'),
                type: 'success',
              });
            }
          });
        }
      },
    },
  };
</script>
